import { AppBar, Button, Menu, MenuItem, Toolbar } from '@mui/material';
import { logout } from 'actions/auth';
import UserContext from 'contexts/user';
import { useSnackbar } from 'notistack';
import { useContext, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import './index.css';
const Header = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();
  const handleLogOut = () => {
    logout();
    setUser();
    history.push('/');
    enqueueSnackbar('Logged out succesfully', {
      variant: 'success',
    });
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="Header">
      <AppBar position="static">
        <Toolbar>
          <div className="header-tabs">
            <Link to="/">
              <Button color="primary" disableElevation variant="contained">
                Home
              </Button>
            </Link>
            <Link to="/challenges">
              <Button color="primary" disableElevation variant="contained">
                Compete
              </Button>
            </Link>
            {/* <Link to="/result">
              <Button color="primary" disableElevation variant="contained">
                Result
              </Button>
            </Link> */}
            {/* <Link to={{pathname: "/result", hash: "awards"}}>
                <Button color="primary" disableElevation variant="contained">
                Awards
                </Button>
                </Link> */}

            {/* <Link to="/about">
                <Button color="primary" disableElevation variant="contained">
                About
                </Button>
                </Link> */}

            {user?.role === 'admin' && (
              <Link to="/admin">
                <Button color="primary" disableElevation variant="contained">
                  Admin
                </Button>
              </Link>
            )}

            <div className="spacer"></div>
            {user ? (
              <>
                <Button
                  color="primary"
                  disableElevation
                  variant="contained"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  Welcome, {user.name}
                </Button>

                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem>
                    <Link style={{ color: 'inherit' }} to="/profile">
                      My Submissions
                    </Link>
                  </MenuItem>
                  <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button color="primary" disableElevation variant="contained">
                    Login/Register
                  </Button>
                </Link>
              </>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
